import { loadableReady } from '@loadable/component';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Store } from 'redux';

import { createRenderCallback } from './internal';
import { ApplicationContainer } from '../../../shared/containers/ApplicationContainer';
import { IState } from '../../../shared/store';
import { IApplicationContext } from '../../../shared/types/applicationContext';

interface IDependencies {
  store: Store<IState>;
  context: IApplicationContext;
}

export function renderApplication({ store, context }: IDependencies) {
  const { config } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  loadableReady(() => {
    ReactDOM.hydrate(
      <ApplicationContainer context={context} reduxStore={store} />,
      rootElement,
      createRenderCallback(),
    );
  });
}
